import React from 'react'
import { View } from '~/pagui'
import CommentForm from './CommentForm'
import CommentNode from './CommentNode'
import { WpPost } from './News'

type Props = {
  post: WpPost
}

const Comments: React.FunctionComponent<Props> = ({ post }) => {
  return (
    <View>
      <CommentForm commentOn={post.databaseId} />
      {post.comments.nodes.map((comment) => {
        return <CommentNode key={comment.id} comment={comment} />
      })}
    </View>
  )
}

export default Comments
